/**
 * Component to display correctly formatted CPD score text.
 */
import { getCpdText } from "@/utils/toolbox";

export default {
  name: "CpdScoreText",
  props: {
    score: { type: Number, default: 0 },
    placement: { type: String, default: "right" },
  },
  computed: {
    cpdText() {
      return getCpdText(this.score);
    },
  },
};
